import { render, staticRenderFns } from "./NavTabsCard.vue?vue&type=template&id=74019126&"
import script from "./NavTabsCard.vue?vue&type=script&lang=js&"
export * from "./NavTabsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports